export function getUserTags(send) {
  return (userId, query, ...args) =>
    send(
      {
        path: '/v2/users/{userId}/tags',
        pathParameters: { userId },
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
